{
	"deploymentId": "local",
	"chainId": 31337,
	"deployedAt": "2026-06-26T06:23:23.281Z",
	"contracts": {
		"FSEnvelopeRegistry": {
			"address": "0x73511669fd4dE447feD18BB79bAFeAC93aB7F31f",
			"abiRef": "ff0785f2d6ec18ac54f04caf8944b32e80931b6e0ba747eea0e46e53494cbb12"
		},
		"FSPaymentValidator": {
			"address": "0xB581C9264f59BF0289fA76D61B2D0746dCE3C30D",
			"abiRef": "5c06b1840e1e307bec4b426803081be2250b1a16a89ed3a3272000bfc5fd0d8f"
		},
		"FSAttachmentRelease": {
			"address": "0xC469e7aE4aD962c30c7111dc580B4adbc7E914DD",
			"abiRef": "bc37a8c681af0849ace7cde4b7005b58679dff2abe8276aaedbdeb31e77ee0e9"
		},
		"MockUSDC": {
			"address": "0x6d925938Edb8A16B3035A4cF34FAA090f490202a",
			"abiRef": "77be5f07a2c0458cde3a847eb4ea83cf0f6686a738a0717baa86936aa2e589fa"
		}
	},
	"transactions": {
		"setSatelliteContracts": "0x21c6e285e37edb2002bfe08210ebf164849eb4f97c8eeaa8a8ebe4e8e63b81ba"
	},
	"deploy": {
		"initialRelayers": [
			"0xcd4E9682172f67f2eA8cf0a9eCF199F3b78e57aD",
			"0x8c11E74D92c6F75373E25802931Cd43bC337847C"
		]
	}
}
